import { BlockedRecordDetails, useBlockedRecordDetails } from '@exam-center/blocked-record-details';
import { BLOCKED_TYPE_TEXT } from '@exam-center/blocked-user-management';
import { NavigateBackLinkWithHistory } from '@exam-center/components';
import { Flex, PageHeader, Text } from '@shared/components';

export default function BlockedRecordDetailsPage() {
  const { blockedUser, blockedRecord } = useBlockedRecordDetails();

  return (
    <>
      <PageHeader
        title={[
          blockedUser.title,
          blockedUser.firstName,
          blockedUser.middleName,
          blockedUser.lastName,
        ]
          .filter(Boolean)
          .join(' ')}
        linkAdornment={
          <NavigateBackLinkWithHistory
            fallbackPath='/admin/blocklist/:blockedUserId'
            fallbackParams={{ blockedUserId: blockedUser.id }}
          />
        }
        subtitleSection={
          <Text color='text.secondary' variant='body2'>
            ประเภทผู้ถูกระงับสิทธิ์: {BLOCKED_TYPE_TEXT[blockedRecord.blockedType]}
          </Text>
        }
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          p: theme.spacing(6),
        })}
      >
        <BlockedRecordDetails />
      </Flex>
    </>
  );
}
